@if (showDialog) {
<div class="dialog-background" (click)="$event.stopPropagation()">
    <div class="dialog-wrapper">
        <div class="dialog-content unsaved-changes-dialog">
            @if (showClose) {
            <button type="button" class="close-button" aria-label="Close dialog" (click)="closeAction()">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            }
            <h2 class="text-message">{{ title }}</h2>
            <p class="text-message dialog-message" [class.dialog-message--multiline]="preserveLineBreaks">
                {{ message }}
            </p>
            <div class="dialog-actions">
                @if (showCancel) {
                <button id="unsaved-changes-cancel" type="button" class="btn btn-default" (click)="cancelAction()">
                    {{ cancelButtonText }}
                </button>
                }
                @if (showConfirm) {
                <button id="unsaved-changes-confirm" type="button" class="btn btn-primary" [disabled]="confirmDisabled"
                    (click)="confirmAction()">
                    {{ confirmButtonText }}
                </button>
                }
            </div>
        </div>
    </div>
</div>
}